import React, { forwardRef } from "react";
import { useEnigmaToken } from "@hooks/useEnigmaToken";
import { TextProps } from "./typography.types";
import { StyledText } from "./text.styles";

export const Text = forwardRef<HTMLParagraphElement, TextProps>(
    ({ children, ...rest }, ref) => {
        const token = useEnigmaToken();
        return (
            <StyledText token={token} {...rest} ref={ref}>
                {children}
            </StyledText>
        );
    }
);

Text.displayName = "Text";
